// Copyright 1999-2018. Plesk International GmbH. All rights reserved.

import { render, createElement, LocaleProvider } from '@plesk/ui-library';
import { Cookie } from '../../jsw/cookie';
import NewsletterSubscription from './NewsletterSubscription';

const COOKIE_NAME = 'plesk-newsletter-subscription-shown';
const COOKIE_EXPIRY = 1000 * 86400;

const getConsent = (getConsentUrl, email, callback) => {
    new Ajax.Request(getConsentUrl, {
        method: 'get',
        parameters: { email },
        onSuccess: transport => {
            const { consents = [] } = transport.responseText.evalJSON();
            callback(consents);
        },
    });
};

const reportConsent = (reportConsentUrl, email, consent, text, callback) => {
    // Prevent annoying dialog if something went wrong
    const date = new Date(Date.now() + COOKIE_EXPIRY);
    Cookie.set(COOKIE_NAME, 1, date.toUTCString(), '/');

    new Ajax.Request(reportConsentUrl, {
        method: 'post',
        parameters: { email, text, consent },
        onSuccess: transport => {
            const data = transport.responseText.evalJSON();
            callback(data.status !== 'error');
        },
        onFailure: () => {
            callback(false);
        },
    });
};

module.exports = ({ container, locale, ...props }) => {
    if (Cookie.get(COOKIE_NAME)) {
        return;
    }

    const { getConsentUrl, email } = props;

    getConsent(getConsentUrl, email, consents => {
        render((
            <LocaleProvider messages={locale}>
                <NewsletterSubscription
                    consents={consents}
                    reportConsent={reportConsent}
                    {...props}
                />
            </LocaleProvider>
        ), container);
    });
};



// WEBPACK FOOTER //
// ./app/newsletter-subscription/index.js